// @ts-nocheck
type FNC = <T extends any>(data?: T) => void

interface IEvents {
  [K: string]: FNC[]
}

export default class EventBus {
  constructor() {
    this.events = {} as IEvents
  }

  static creatBus() {
    return new EventBus()
  }

  emit<T>(eventName: string, data?: T) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(function (fn: FNC) {
        fn(data)
      })
    }
  }

  on(eventName: string, fn: FNC) {
    this.events[eventName] = this.events[eventName] || []
    this.events[eventName] = [fn]
  }

  off(eventName: string, fn: FNC) {
    if (this.events[eventName]) {
      for (var i = 0; i < this.events[eventName].length; i++) {
        if (this.events[eventName][i] === fn) {
          this.events[eventName].splice(i, 1)
          break
        }
      }
    }
  }
}
